import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import "./Banner.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NotFoundPage from "./404Page";
import ErrorBoundary from "./ErrorBoundary";
import LowercaseRedirect from "./components/common/LowercaseRedirect";
import Home from "./components/home/Home";
import AboutUs from "./components/about/AboutUs";
import VisionMission from "./components/about/VissionMission";
import DignitariesMessage from "./components/about/DignitariesMessage";
import RTI from "./components/about/RTI";
import Awards from "./components/about/Awards";
import CocHostel from "./components/about/CocHostel";
import Cocmanagement from "./components/about/Cocmanagement";
import CocFaculty from "./components/about/CocFaculty";
import CocStudent from "./components/about/CocStudent";
import CodeOfConduct from "./components/about/CodeOfConduct";
import HonorableVisitor from "./components/about/HonorableVisitor";
import HonorablePatron from "./components/about/HonorablePatron";
import HonorableChancellor from "./components/about/HonorableChancellor";
import HonorableViceChancellor from "./components/about/HonorableViceChancellor";
import OfficialRegistar from "./components/about/OfficialRegistar";
import StatuesOrdinance from "./components/about/StatuesOrdinance";
import GoverningBody from "./components/about/GoverningBody";
import Recognisation from "./components/about/Recognisation";
import BoardManagement from "./components/about/BoardManagement";
import AcademicCouncil from "./components/about/AcademicCouncil";
import BoardAdvisors from "./components/about/BoardAdvisors";
import OtherCommittees from "./components/about/OtherCommittees";
import Media from "./components/about/Media";
import Faculty from "./components/about/Faculty";
import IQAC from "./components/about/IQAC";
import Contactus from "./components/about/Contactus";
import NewsEvents from "./components/about/NewsEvents";
import PrivacyPolicy from "./components/about/PrivacyPolicy";
import TermsCondition from "./components/about/TermsCondition";
import RefundPolicy from "./components/about/RefundPolicy";
import CourseFinderPage from "./components/common/CourseFinderPage";

import NAAC from "./components/about/NAAC";
import AACSB from "./components/about/AACSB";
import IAU from "./components/about/IAU";

import AcademicPhilosophy from "./components/academics/AcademicPhilosophy";
import AcademicPartners from "./components/academics/AcademicPartners";
import TeachingMethodology from "./components/academics/TeachingMethodology";
import OnlineResources from "./components/academics/OnlineResources";
import MOOC from "./components/academics/MOOC";
import MOUs from "./components/academics/MOUs";

import CourseDetails from "./components/academics/CourseDetails";
import SchoolDetails from "./components/academics/SchoolDetails";

import Admissionhelpdesk from "./components/admission/AdmissionHelpdesk";
import Admissionprocedure from "./components/admission/AdmissionProcedure";
import Paymentprocedure from "./components/admission/PaymentProcedure";
import ProgrammesByQualification from "./components/admission/ProgrammesByQualification";
import ProgrammesAndEligibilities from "./components/admission/ProgrammesAndEligibilities";
import SkillDevelopment from "./components/admission/SkillDevelopment";
import Research from "./components/admission/Research";
import OnlinePayment from "./components/admission/OnlinePayment";
import ApplyOnline from "./components/admission/ApplyOnline";
import PayOnline from "./components/admission/PayOnline";
import ShowApplication from "./components/admission/ShowApplication";
import Dora from "./components/admission/Dora";

import GraduationProgrammes from "./components/academics/GraduationProgrammes";
import PostGraduationProgrammes from "./components/academics/PostGraduationProgrammes";
import CertificateProgrammes from "./components/academics/CertificateProgrammes";
import DiplomaProgrammes from "./components/academics/DiplomaProgrammes";

import Placement from "./components/placement/Placements";
import Career from "./components/placement/CareerCounselling";
import GlobalSkills from "./components/placement/GlobalSkills";
import Recruiters from "./components/placement/Recruiters";
import InterviewTraining from "./components/placement/InterviewTraining";
import WorkIsbm from "./components/placement/WorkIsbm";

import Sports from "./components/campus/Sports";
import Hostel from "./components/campus/Hostel";
import Library from "./components/campus/Library";
import Transport from "./components/campus/Transport";
import Laboratory from "./components/campus/Laboratory";
import ExtraCurricular from "./components/campus/ExtraCurricular";
import CampusInfrastructure from "./components/campus/CampusInfrastructure";
import Elibrary from "./components/campus/Elibrary";
import RaipurCampus from "./components/campus/RaipurCampus";
import GariyabandCampus from "./components/campus/GariyabandCampus";

import Management from "./components/about/Management";
import LeadershipManagement from "./components/about/LeadershipManagement";
import DigitizedLearningSystem from "./components/campus/DigitizedLearningSystem";

import Faqs from "./components/studentservices/Faqs";
import Scholarship from "./components/studentservices/Scholarship";
import AntiRagging from "./components/studentservices/AntiRagging";
import ScheduledCaste from "./components/studentservices/ScheduledCaste";
import RaggingCommittees from "./components/studentservices/RaggingCommittees";
import OtherBackward from "./components/studentservices/OtherBackward";
import StudentsGrievence from "./components/studentservices/StudentsGrievence";
import InternalComplaints from "./components/studentservices/InternalComplaints";
import CulturalCommittee from "./components/studentservices/CulturalCommittee";
import StudentCouncil from "./components/studentservices/StudentCouncil";
import Downloads from "./components/studentservices/Downloads";
import RaggingPolicy from "./components/studentservices/RaggingPolicy";
import StudentGrievance from "./components/studentservices/StudentGrievance";

import Internationalpartnership from "./components/International/international_partnership";
import Internationalstudent from "./components/International/international_student";
import ProspectiveInternational from "./components/International/ProspectiveInternational";

import Thankyou from "./components/common/ThankYou";
import EventDetail from "./components/home/EventDetail";
import NewsDetail from "./components/home/NewsDetail";
import BlogList from "./components/academics/BlogList";
import BlogDetails from "./components/academics/BlogDetails";
import AcademicCalender from "./components/academics/AcademicCalender";

import LP from "./components/LP/LP";

const App = () => {
  const [isRootEmpty, setIsRootEmpty] = useState(false);

  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (!rootDiv || rootDiv.innerHTML.trim() === "") {
      setIsRootEmpty(true);
    }
  }, []);

  if (isRootEmpty) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Router>
      <ErrorBoundary>
        {/* Redirect to lowercase if needed */}
        <LowercaseRedirect />
        <Routes>
          {/* Default route */}
          <Route path="/" element={<LP />} />
          <Route path="/home" element={<Home />} />

          {/* Aliases for home */}
          {/* <Route path="/home" element={<Navigate to="/" replace />} /> */}
          <Route path="/thank-you" element={<Thankyou />} />
          <Route path="/event-details/:eventId" element={<EventDetail />} />
          <Route path="/news-details/:newsId" element={<NewsDetail />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          {/* About Us */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/vision-mission" element={<VisionMission />} />
          <Route
            path="/leadership-and-management"
            element={<LeadershipManagement />}
          />
          <Route path="/university-administration" element={<Management />} />
          <Route path="/honorable-visitor" element={<HonorableVisitor />} />
          <Route path="/honorable-patron" element={<HonorablePatron />} />
          <Route
            path="/honorable-chancellor"
            element={<HonorableChancellor />}
          />
          <Route
            path="/honorable-vice-chancellor"
            element={<HonorableViceChancellor />}
          />
          <Route path="/official-registar" element={<OfficialRegistar />} />
          <Route path="/RTI" element={<RTI />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/iqac" element={<IQAC />} />
          <Route
            path="/dignitaries-messages"
            element={<DignitariesMessage />}
          />
          <Route
            path="/code-of-conduct-boardes-of-hostel"
            element={<CocHostel />}
          />
          <Route
            path="/code-of-conduct-management"
            element={<Cocmanagement />}
          />
          <Route path="/code-of-conduct-faculty" element={<CocFaculty />} />
          <Route path="/code-of-conduct-student" element={<CocStudent />} />
          <Route path="/code-of-conduct-and-rti" element={<CodeOfConduct />} />

          <Route path="/statues-and-ordinance" element={<StatuesOrdinance />} />
          <Route
            path="/dignitaries-messages"
            element={<DignitariesMessage />}
          />
          <Route path="/governing-body" element={<GoverningBody />} />
          <Route
            path="/accreditation-and-recognitions"
            element={<Recognisation />}
          />
          <Route path="/board-management" element={<BoardManagement />} />
          <Route path="/academic-council" element={<AcademicCouncil />} />
          <Route path="/board-advisor" element={<BoardAdvisors />} />
          <Route path="/other-communitie" element={<OtherCommittees />} />
          <Route path="/media-coverage" element={<Media />} />
          <Route path="/faculty-list" element={<Faculty />} />
          <Route path="/naac-accreditation" element={<NAAC />} />
          <Route path="/aacsb-accreditation" element={<AACSB />} />
          <Route path="/iau-accreditation" element={<IAU />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/news-events" element={<NewsEvents />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsCondition />} />

          {/* academics */}
          <Route path="/academic-philosophy" element={<AcademicPhilosophy />} />
          <Route path="/academic-partner" element={<AcademicPartners />} />
          <Route
            path="/teaching-methodology-pedagogy"
            element={<TeachingMethodology />}
          />
          <Route path="/online-resources" element={<OnlineResources />} />
          <Route path="/mooc-with-isbm" element={<MOOC />} />
          <Route path="/mous-and-collaborations" element={<MOUs />} />
          <Route path="/pay-fees-online" element={<OnlinePayment />} />
          <Route path="/apply-online" element={<ApplyOnline />} />
          <Route path="/pay-online" element={<PayOnline />} />
          <Route path="/show-application" element={<ShowApplication />} />

          {/* school */}
          <Route
            path="/course-details/:courseName"
            element={<CourseDetails />}
          />
          <Route
            path="/school-details/:schoolName"
            element={<SchoolDetails />}
          />
          {/* admission */}
          <Route
            path="/programmes-and-eligibilities"
            element={<ProgrammesAndEligibilities />}
          />
          <Route
            path="/programmes-by-qualification"
            element={<ProgrammesByQualification />}
          />
          <Route
            path="/admission-procedure-guidelines"
            element={<Admissionprocedure />}
          />
          <Route path="/skill-development" element={<SkillDevelopment />} />

          <Route path="/skill-development" element={<SkillDevelopment />} />

          <Route path="/research" element={<Research />} />
          <Route path="/admission-help-desk" element={<Admissionhelpdesk />} />
          <Route
            path="/payment-procedure-guidelines"
            element={<Paymentprocedure />}
          />
          <Route
            path="/graduate-programmes"
            element={<GraduationProgrammes />}
          />
          <Route
            path="/post-graduate-programmes"
            element={<PostGraduationProgrammes />}
          />
          <Route path="/diploma-programmes" element={<DiplomaProgrammes />} />
          <Route
            path="/certificate-programmes"
            element={<CertificateProgrammes />}
          />
          <Route
            path="/public-statement-detailing-our-commitment-to-dora"
            element={<Dora />}
          />

          {/* Campus */}
          <Route path="/sports-facilities" element={<Sports />} />
          <Route path="/laboratory" element={<Laboratory />} />

          <Route path="/library" element={<Library />} />

          <Route path="/bus-transportation" element={<Transport />} />

          <Route path="/hostel" element={<Hostel />} />
          {/* <Route
            path="/campus-infrastructure"
            element={<CampusInfrastructure />}
          /> */}
          <Route path="/gariyaband-campus" element={<GariyabandCampus />} />
          <Route path="/raipur-campus" element={<RaipurCampus />} />

          <Route path="/e-library" element={<Elibrary />} />

          {/* Placement */}
          <Route path="/about-placements" element={<Placement />} />
          <Route path="/global-readiness" element={<GlobalSkills />} />
          <Route path="/recruiters" element={<Recruiters />} />
          <Route
            path="/campus-recruitment-interview-training"
            element={<InterviewTraining />}
          />
          <Route path="/work-at-isbmu" element={<WorkIsbm />} />
          <Route path="/career-counselling" element={<Career />} />

          <Route path="/faqs" element={<Faqs />} />
          <Route path="/scholarship" element={<Scholarship />} />
          <Route path="/anti-ragging-squad" element={<AntiRagging />} />
          <Route path="/sc-and-st-committee" element={<ScheduledCaste />} />
          <Route
            path="/anti-ragging-committee"
            element={<RaggingCommittees />}
          />
          <Route path="/obc-committee" element={<OtherBackward />} />
          <Route
            path="/student-grievance-committee"
            element={<StudentsGrievence />}
          />
          <Route path="/icc-committee" element={<InternalComplaints />} />
          <Route path="/cultural-committee" element={<CulturalCommittee />} />
          <Route path="/student-council" element={<StudentCouncil />} />
          <Route path="/download-form" element={<Downloads />} />
          <Route path="/anti-ragging-policy" element={<RaggingPolicy />} />
          <Route path="/student-grievance" element={<StudentGrievance />} />

          {/* International */}
          <Route
            path="/prospective-international-students"
            element={<ProspectiveInternational />}
          />
          <Route
            path="/international-partnerships"
            element={<Internationalpartnership />}
          />
          <Route
            path="/international-students"
            element={<Internationalstudent />}
          />
          <Route path="/extra-curricular" element={<ExtraCurricular />} />

          <Route
            path="/digitized-learning-system"
            element={<DigitizedLearningSystem />}
          />

          <Route path="/academic-calender" element={<AcademicCalender />} />

          <Route path="/all-courses" element={<CourseFinderPage />} />

          <Route path="/blog" element={<BlogList />} />

          <Route path="/:url" element={<BlogDetails />} />

          {/* 404 Handling */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
};

export default App;
